import clsx from 'clsx';
import React from 'react';

import useEventTracking from '@hooks/useEventTracking';

import type { ArticleClusterBlockProps } from '../interfaces';
import Item from './Item';

const ArticleClusterBlock = ({ articleClusters, config }: ArticleClusterBlockProps) => {
  const { Track } = useEventTracking({
    ...(config?.analytics_location ? { location: config.analytics_location } : {}),
  });

  const { headline, items } = articleClusters;

  return (
    <article
      className={clsx('article-cluster-block mt-64 sm:mt-96 md:mt-112', config?.css_classes)}
    >
      <header>
        <h2 className="m-0 text-center font-suisse-works text-headline-xxs text-black sm:text-headline-xs md:text-headline-sm lg:text-headline-xs">
          {headline}
        </h2>
      </header>
      <div className="mt-32 flex flex-col justify-center sm:mt-48 sm:flex-row sm:flex-wrap sm:gap-48 lg:flex-nowrap">
        <Track>
          {items.map((item) => (
            <Item
              key={item?.id}
              showByline={config?.show_bylines}
              showImage={config?.show_images}
              showTimestamp={config?.show_timestamps}
              {...item}
            />
          ))}
        </Track>
      </div>
    </article>
  );
};

export default ArticleClusterBlock;
